import { TableRow, TableCell } from "@mui/material";
import { Talent, talentIsDisabled } from "../../talents/talentAPI";
import { ActionsIconButton } from "../../../common/components/styled/styled";
import { MoreVert as MoreIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { getName } from "../../../common/helpers/common";

type Props = {
  talent: Talent;
  onMenuOpen: (anchorEl: HTMLButtonElement, talent: Talent) => void;
};

export const TalentTableRow = ({ talent, onMenuOpen }: Props) => {
  const { t } = useTranslation();

  return (
    <TableRow
      key={talent.id}
      sx={{
        ...(talentIsDisabled(talent) ? { opacity: "0.5" } : { opacity: "1" }),
      }}
    >
      <TableCell>{getName(talent.account)}</TableCell>
      <TableCell>{talent.account.emailAddress}</TableCell>
      <TableCell>{talent.account.phoneNumber}</TableCell>
      <TableCell>
        {talentIsDisabled(talent) ? t("common:no") : t("common:yes")}
      </TableCell>
      <TableCell>
        <ActionsIconButton
          size="small"
          onClick={(ev) => onMenuOpen(ev.currentTarget, talent)}
        >
          <MoreIcon />
        </ActionsIconButton>
      </TableCell>
    </TableRow>
  );
};
